module.exports = __webpack_public_path__ + "img/icn-filter-05.e0d6c38d.svg";